import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import MaterialIcon from "shared/react_components/MaterialIcon";

import { icon } from "./legend.module.scss";

const LegendItem = ({ className, color, children }) => (
  <label className="d-flex align-items-center">
    <MaterialIcon
      name="lens"
      className={classNames(icon, className)}
      style={{ color }}
    />
    {children}
  </label>
);

LegendItem.propTypes = {
  /**
   * Attaches a className to the item's dot. Can be used in place of color prop to set the color.
   */
  className: PropTypes.string,
  /**
   * Sets the color of item's dot. Can be used in place of className and takes precedence.
   */
  color: PropTypes.string,
  /**
   * The item's label text.
   */
  children: PropTypes.node.isRequired
};

LegendItem.defaultProps = {
  className: "",
  color: ""
};

export default LegendItem;
